import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLocale } from '../context/LocaleContext';
import type { Locale } from '../i18n/translations';
import './LanguageSwitcher.css';

const LanguageSwitcher: React.FC = () => {
  const { locale, setLocale } = useLocale();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLocale = (newLocale: Locale) => {
    setLocale(newLocale);
    const pathname = location.pathname;
    if (newLocale === 'en') {
      if (/^\/da(?:\/|$)/.test(pathname)) {
        const withoutDa = pathname.replace(/^\/da/, '') || '/';
        navigate(withoutDa + location.search + location.hash, { replace: true });
      }
    } else {
      if (pathname === '/' || pathname === '/blog' || pathname.startsWith('/blog/') || pathname === '/resume') {
        const path = pathname === '/' ? '' : pathname.slice(1);
        navigate(`/da${path ? '/' + path : ''}` + location.search + location.hash, { replace: true });
      }
    }
  };

  return (
    <div className="language-switcher" role="group" aria-label="Language">
      <button
        type="button"
        className={`language-switcher-btn ${locale === 'en' ? 'active' : ''}`}
        onClick={() => handleLocale('en')}
        aria-pressed={locale === 'en'}
        lang="en"
      >
        EN
      </button>
      <span className="language-switcher-sep" aria-hidden>
        |
      </span>
      <button
        type="button"
        className={`language-switcher-btn ${locale === 'da' ? 'active' : ''}`}
        onClick={() => handleLocale('da')}
        aria-pressed={locale === 'da'}
        lang="da"
      >
        DA
      </button>
    </div>
  );
};

export default LanguageSwitcher;
